/**
 * fundacaoBuilder (S1) — agenciadores, templates de e-mail, integrações
 * externas e config financeira do tenant.
 *
 * @since S1 (gaps SA→AVA)
 */
import type { $Fetch } from 'ofetch';

import {
  HttpAgenciadorGateway, HttpEmailTemplateGateway,
  HttpExternalIntegrationGateway, HttpTenantFinancialConfigGateway,
} from '@/infrastructure/http/HttpFundacaoGateways';
import {
  ListAgenciadores, CreateAgenciador, UpdateAgenciador, RemoveAgenciador,
  ListEmailTemplates, CreateEmailTemplate, UpdateEmailTemplate, RemoveEmailTemplate, PreviewEmailTemplate,
  ListIntegracoes, CreateIntegracao, UpdateIntegracao, RemoveIntegracao,
  GetTenantFinancialConfig, SaveTenantFinancialConfig,
} from '@/application/usecase/FundacaoUseCaseImpl';

export function buildFundacaoSlice(httpClient: $Fetch) {
  const agenciadorGateway = new HttpAgenciadorGateway(httpClient);
  const emailTemplateGateway = new HttpEmailTemplateGateway(httpClient);
  const integracaoGateway = new HttpExternalIntegrationGateway(httpClient);
  const finConfigGateway = new HttpTenantFinancialConfigGateway(httpClient);

  const useCases = {
    listAgenciadores: new ListAgenciadores(agenciadorGateway),
    createAgenciador: new CreateAgenciador(agenciadorGateway),
    updateAgenciador: new UpdateAgenciador(agenciadorGateway),
    removeAgenciador: new RemoveAgenciador(agenciadorGateway),
    listEmailTemplates: new ListEmailTemplates(emailTemplateGateway),
    createEmailTemplate: new CreateEmailTemplate(emailTemplateGateway),
    updateEmailTemplate: new UpdateEmailTemplate(emailTemplateGateway),
    removeEmailTemplate: new RemoveEmailTemplate(emailTemplateGateway),
    previewEmailTemplate: new PreviewEmailTemplate(emailTemplateGateway),
    listIntegracoes: new ListIntegracoes(integracaoGateway),
    createIntegracao: new CreateIntegracao(integracaoGateway),
    updateIntegracao: new UpdateIntegracao(integracaoGateway),
    removeIntegracao: new RemoveIntegracao(integracaoGateway),
    getTenantFinancialConfig: new GetTenantFinancialConfig(finConfigGateway),
    saveTenantFinancialConfig: new SaveTenantFinancialConfig(finConfigGateway),
  };

  return { useCases };
}
